// @flow
import React, { Component } from 'react';
import Circles from 'components/common/Loaders/Circles';
import OrderRefundTemplate from 'components/order/OrderRefundTemplate';
import type { State } from 'store';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { OrdersActions } from '../../store/actionCreators';

type Props = {
  order: any,
};

class OrderRefundTemplateContainer extends Component<Props> {
  state = {
    reasonCategory: null,
    reason: '',
    refundProductAmount: 0,
    refundShippingFee: 0,
    refundTotal: 0
  };

  initialize = async () => {
    try {
      const { orderId } = this.props.match.params;
      await OrdersActions.getOrder(orderId);
      const itemList = [];
      for (let i=0; i<this.props.order.refunds.length; i+=1) {
        if (this.props.order.refunds[i].status === 'requested'){
          for (let j=0; j<this.props.order.refunds[i].items.length; j+=1) {
            itemList.push(this.props.order.refunds[i].items[j].item.id)
          }
        }
      }
      await OrdersActions.updateRefundList(itemList);
    } catch (e) {
      console.log(e);
    }
  };

  componentDidMount() {
    this.initialize();
  }

  handleChange = (e: any) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onRefundQuantity = (payload) => {
    const { index, quantity } = payload;
    if (quantity === 0) {
      OrdersActions.updateRemoveRefund(index);
    } else {
      OrdersActions.updateRefundQuantity(payload);
    }
  }

  onAddRefund = (index) => {
    OrdersActions.updateAddRefund(index);
  }

  onRemoveRefund = (index) => {
    OrdersActions.updateRemoveRefund(index);
  }

  // eslint-disable-next-line consistent-return
  // onOrderRefund = async () => {
  //   if (!this.state.reasonCategory) return alert('환불 사유를 선택 해주세요.');
  //
  //   const orderId = this.props.order.id;
  //   const items = [];
  //   // eslint-disable-next-line array-callback-return
  //   this.props.order.items.map((item) => {
  //     if (item.refunded) {
  //       items.push({
  //         item: item.id,
  //         quantity: item.refundQuantity,
  //       })
  //     }
  //   });
  //   const payload = {
  //     items,
  //     reason: `[${this.state.reasonCategory}] ${this.state.reason}`,
  //   };
  //   if (this.props.order.total.shipping.fee.sale.raw > 0) {
  //     payload.shipments = this.props.order.total.shipping.fee.sale.raw;
  //   }
  //   await OrdersActions.requestRefund(orderId, payload);
  //   await OrdersActions.updateTransactions(orderId);
  //   await OrdersActions.getOrder(orderId);
  //   await this.props.history.push(`/orders/${orderId}`);
  // }

  // eslint-disable-next-line consistent-return
  onOrderRefund = async () => {
    if (!this.state.reasonCategory) return alert('환불 상태를 선택 해주세요.');

    const orderId = this.props.order.id;
    const shipping = Number(this.state.reasonCategory === '제품 하자' ? this.props.order.total.shipping.fee.sale.raw : 0);
    const total = Math.floor((this.props.order.items
      .filter(item => item.refunded)
      .reduce((accumulator, currentItem) => {
        return accumulator + (currentItem.refundQuantity * currentItem.price.sale.raw);
      }, 0) + shipping) * 1.1);

    let payload = {
      cancellation: null,
      createdAt: {
        raw: new Date().toISOString(),
      },
      items: [],
      reason: `[${this.state.reasonCategory}] ${this.state.reason}`,
      shipments: [],
      status: 'requested',
      total: {
        items: {
          price: {
            withTax: {
              raw: total,
            },
          },
        },
        price: {
          withTax: {
            raw: total,
          },
        },
        shipping: {
          fee: {
            withTax: {
              raw: shipping,
            },
          },
        },
      },
      updatedAt: {
        raw: new Date().toISOString(),
      },
      id: '',
      _id: ''
    }

    // eslint-disable-next-line array-callback-return
    this.props.order.items.map((item) => {
      if (item.refunded) {
        payload.items.push({
          item,
          quantity: {
            raw: item.refundQuantity,
          }
        })
      }
    });
    // if (this.props.order.total.shipping.fee.sale.raw > 0) {
    //   payload.shipments = this.props.order.total.shipping.fee.sale.raw;
    // }
    await OrdersActions.requestRefund(orderId, payload);
    // await OrdersActions.updateTransactions(orderId);
    await OrdersActions.getOrder(orderId);
    await this.props.history.push(`/orders/${orderId}`);
  }

  render() {
    if(this.props.loading === undefined || this.props.loading) return <Circles color="blue" size="medium" text="Loading..." />;
    return (
      <OrderRefundTemplate
        order={this.props.order}
        reason={this.state.reason}
        reasonCategory={this.state.reasonCategory}
        handleChange={this.handleChange}
        onAddRefund={this.onAddRefund}
        onRemoveRefund={this.onRemoveRefund}
        onOrderRefund={this.onOrderRefund}
        onRefundQuantity={this.onRefundQuantity}
      />
    );
  }
}

export default connect(
  ({ orders, pender }: State) => ({
    order: orders && orders.order,
    loading: pender.pending['orders/GET_ORDER'],
  }),
  () => ({}),
)(withRouter(OrderRefundTemplateContainer));



// WEBPACK FOOTER //
// ./src/containers/order/OrderRefundTemplateContainer.js